<mat-menu id="lnr-profile-menu-root" xPosition="before">
  <button id="lnr-menu-router-to-account-settings"
          mat-menu-item
          [routerLink]="'/' + routes.ACCOUNT_SETTINGS">{{ profileMenuItems.accountSettings }}</button>
  <button id="lnr-menu-router-to-logout" mat-menu-item (click)="onLogout()">{{ profileMenuItems.logout }}</button>
</mat-menu>
